let scriptLoaded = false
let loadingPromise = null

const loadConfettiScript = () => {
  if (scriptLoaded) return Promise.resolve()
  if (loadingPromise) return loadingPromise

  loadingPromise = new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js'
    script.onload = () => {
      scriptLoaded = true
      resolve()
    }
    document.body.appendChild(script)
  })

  return loadingPromise
}

export const launchConfetti = async () => {
  await loadConfettiScript()
  window.confetti({
    particleCount: 50,
    spread: 60,
    origin: { y: 0.6 },
    colors: ['#FF6B9D', '#4A90E2', '#FFFFFF']
  })
}
